import { useState } from "react";
import { toast } from "sonner";
import { p, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { Check, ArrowRight } from "lucide-react";

const FATTO = [
  "Comanda aperta e inviata ai reparti, senza foglietti",
  "Tempi di attesa in cucina e al bancone sotto controllo",
  "Conto e cassa della giornata aggiornati da soli",
  "Fondo cassa dello staff assegnato dal titolare, con quadratura a fine giornata",
];

/** Fine del percorso: si riassume cosa ha fatto e si raccoglie il contatto, senza insistere. */
export const DemoFinale = ({ onClose }) => {
  const [locale, setLocale] = useState("");
  const [citta, setCitta] = useState("");
  const [tel, setTel] = useState("");
  const [busy, setBusy] = useState(false);
  const [inviato, setInviato] = useState(false);

  const manda = async () => {
    if (locale.trim().length < 2) return toast.error("Scrivi il nome della tua attività");
    if (tel.trim().length < 6) return toast.error("Scrivi un numero dove richiamarti");
    setBusy(true);
    try {
      await p("/public/interesse", { business: locale.trim(), city: citta.trim(), phone: tel.trim(),
                                     source: "demo-guidata" });
      setInviato(true);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open onOpenChange={() => onClose?.()}>
      <DialogContent className="max-h-[92vh] overflow-y-auto border-slate-800 bg-slate-900 text-slate-100 sm:max-w-md"
                     data-testid="demo-finale-page">
        <DialogTitle className="font-num text-[10px] font-bold uppercase tracking-[0.24em] text-amber-400">
          Percorso completato
        </DialogTitle>

        {inviato ? (
          <div className="space-y-4 py-2" data-testid="demo-finale-grazie">
            <p className="font-head text-xl font-bold">Richiesta registrata</p>
            <p className="text-sm text-slate-300">
              Ti richiamiamo noi per configurare il tuo locale: menu, tavoli e squadra. Alla prima
              serata lo usi già, senza corsi e senza impegni.
            </p>
            <Button className="w-full" onClick={onClose} data-testid="demo-finale-continue-demo-btn">
              Continua a guardare la demo
            </Button>
          </div>
        ) : (
          <>
            <p className="font-head mt-1 text-xl font-bold">Hai gestito un tavolo dall'inizio alla fine</p>
            <ul className="mt-3 space-y-2">
              {FATTO.map((x) => (
                <li key={x} className="flex gap-2 text-sm text-slate-300">
                  <Check className="mt-0.5 h-4 w-4 shrink-0 text-emerald-400" /> {x}
                </li>
              ))}
            </ul>

            <div className="mt-4 space-y-2.5 rounded-xl border border-slate-800 bg-slate-950/60 p-4">
              <p className="text-sm font-semibold">Vuoi vederlo sul tuo locale?</p>
              <p className="text-xs text-slate-400">
                Lo prepariamo noi con il tuo menu e i tuoi tavoli. Durante la beta non si paga nulla
                e non serve la carta.
              </p>
              <Input className="h-11 border-slate-700 bg-slate-900" placeholder="Nome dell'attività"
                     value={locale} onChange={(e) => setLocale(e.target.value)}
                     data-testid="demo-finale-activity-input" />
              <Input className="h-11 border-slate-700 bg-slate-900" placeholder="Città"
                     value={citta} onChange={(e) => setCitta(e.target.value)}
                     data-testid="demo-finale-city-input" />
              <Input className="h-11 border-slate-700 bg-slate-900" placeholder="Telefono o WhatsApp"
                     value={tel} onChange={(e) => setTel(e.target.value)}
                     data-testid="demo-finale-phone-input" />
              <Button className="h-12 w-full" disabled={busy} onClick={manda} data-testid="demo-finale-submit-btn">
                {busy ? "Invio…" : <>Chiedimi di configurarlo <ArrowRight className="ml-1.5 h-4 w-4" /></>}
              </Button>
            </div>

            <button onClick={onClose} className="mt-1 w-full py-2 text-xs font-semibold text-slate-400"
                    data-testid="demo-finale-close-btn">
              Resto a guardare la demo
            </button>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};
